"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Clear_1 = tslib_1.__importDefault(require("@mui/icons-material/Clear"));
const Search_1 = tslib_1.__importDefault(require("@mui/icons-material/Search"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Input_1 = tslib_1.__importDefault(require("@mui/material/Input"));
const InputAdornment_1 = tslib_1.__importDefault(require("@mui/material/InputAdornment"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const styles_1 = require("@mui/material/styles");
const SearchSettingsPopover_1 = tslib_1.__importDefault(require("./SearchSettingsPopover"));
const Styles_1 = tslib_1.__importDefault(require("./Styles"));
/**
 *
 * A component to be used as the main search input in a search form containing form controls wrapped in {@link FilterBox}-components.
 *
 * @example
 *
 * Basic example showing the SearchBar
 *
 * ```jsx live noInline
 * file://./__examples__/1_SearchBar.jsx
 * ```
 *
 * @example
 *
 * Displays the SearchBar with the SearchSettingsPopover enabled.
 * The SearchSettingsPoperover end adornment is enable if the SearchSettingsPopoverProps object is passed as a prop to the SearchBar component
 *
 * ```jsx live noInline
 * file://./__examples__/2_SearchBarWithSearchSettings.jsx
 * ```
 * @category component
 *
 */
const SearchBar = (props, inputRef) => {
    const theme = (0, styles_1.useTheme)();
    const styles = (0, Styles_1.default)({ theme });
    const { onClickSearchIcon, onClickClearIcon, value, PaperProps, SearchSettingsPopoverProps = null, ...rest } = props;
    return (react_1.default.createElement(Box_1.default, { sx: styles.line },
        react_1.default.createElement(Paper_1.default, { sx: styles.paper, onClick: props.onFocus, ...PaperProps },
            react_1.default.createElement(Input_1.default, { inputProps: { role: "searchbox" }, fullWidth: true, disableUnderline: true, startAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "start", sx: styles.startAdornment },
                    react_1.default.createElement(IconButton_1.default, { onClick: onClickSearchIcon, sx: { p: 1 }, tabIndex: -1, size: "large" },
                        react_1.default.createElement(Search_1.default, { sx: styles.icon }))), endAdornment: react_1.default.createElement(react_1.default.Fragment, null,
                    value && (react_1.default.createElement(InputAdornment_1.default, { position: "end", sx: styles.endAdornment },
                        react_1.default.createElement(IconButton_1.default, { size: "small", onClick: onClickClearIcon, tabIndex: -1 },
                            react_1.default.createElement(Clear_1.default, { sx: styles.icon })))),
                    SearchSettingsPopoverProps && (react_1.default.createElement(InputAdornment_1.default, { position: "end", sx: styles.endAdornment },
                        react_1.default.createElement(Divider_1.default, { orientation: "vertical", sx: styles.divider }),
                        react_1.default.createElement(SearchSettingsPopover_1.default, { ...SearchSettingsPopoverProps })))), ...{ ...rest, value, ref: inputRef } }))));
};
exports.SearchBar = SearchBar;
const SearchBarWithRef = react_1.default.forwardRef(exports.SearchBar);
exports.default = SearchBarWithRef;
